if (!customElements.get('scroll-story')) {
  customElements.define(
    'scroll-story',
    class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('[data-scroll-story-slide]')];
        this.frame = null;
        this.controller = new AbortController();
        this.scroller = this.closest('.page-wrapper') || window;
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.slides.forEach((slide) => {
          const text = slide.querySelector('[data-scroll-story-text]');
          if (text) this.resizeObserver.observe(text);
        });
        this.classList.add('scroll-story--ready');
        window.addEventListener('scroll', () => this.requestUpdate(), {
          passive: true,
          signal: this.controller.signal,
        });
        if (this.scroller !== window) {
          this.scroller.addEventListener('scroll', () => this.requestUpdate(), {
            passive: true,
            signal: this.controller.signal,
          });
        }
        window.addEventListener('resize', () => this.measure(), {
          passive: true,
          signal: this.controller.signal,
        });
        document.addEventListener(
          'shopify:block:select',
          (event) => {
            const target = event.target;
            const slide = target instanceof Element ? target.closest('[data-scroll-story-slide]') : null;
            if (slide && this.contains(slide)) slide.scrollIntoView({ behavior: 'smooth', block: 'start' });
          },
          { signal: this.controller.signal }
        );
        this.measure();
      }

      disconnectedCallback() {
        this.controller.abort();
        this.resizeObserver.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      measure() {
        const viewportHeight = window.innerHeight;
        this.slides.forEach((slide) => {
          const text = slide.querySelector('[data-scroll-story-text]');
          const overflow = text ? Math.max(0, text.scrollHeight - viewportHeight * 0.42) : 0;
          slide.style.setProperty('--slide-scroll-height', `${viewportHeight * 5 + overflow * 2}px`);
          slide.dataset.textOverflow = String(overflow);
        });
        this.requestUpdate();
      }

      requestUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }

      range(value, start, end) {
        const progress = Math.min(1, Math.max(0, (value - start) / (end - start)));
        return progress * progress * (3 - 2 * progress);
      }

      update() {
        const viewportHeight = window.innerHeight;
        this.slides.forEach((slide) => {
          const rect = slide.getBoundingClientRect();
          const distance = Math.max(1, rect.height - viewportHeight);
          const progress = Math.min(1, Math.max(0, -rect.top / distance));
          const titleIn = this.range(progress, 0.04, 0.16);
          const textIn = this.range(progress, 0.16, 0.3);
          const imageIn = this.range(progress, 0.5, 0.62);
          const copyOut = 1 - this.range(progress, 0.66, 0.78);
          const textTravel = Number(slide.dataset.textOverflow || 0) * this.range(progress, 0.3, 0.52);

          slide.style.setProperty('--title-opacity', titleIn * copyOut);
          slide.style.setProperty('--title-shift', `${(1 - titleIn) * 24}px`);
          slide.style.setProperty('--text-opacity', textIn * copyOut);
          slide.style.setProperty('--text-shift', `${(1 - textIn) * 24 - textTravel}px`);
          slide.style.setProperty('--media-opacity', imageIn);
        });
      }
    }
  );
}
